import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OfferKey } from '@assetaccountant/core/models/offers/offer-key';
import { OfferInstance } from '@assetaccountant/core/models/offers/offer-instance';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  constructor(private http: HttpClient) {}

  getOffer(offerKey: OfferKey): Observable<OfferInstance> {
    if (offerKey.couponId == null)
      return this.http.get<OfferInstance>(
        `${environment.servicesApiUrl}/api/v3/offers/${offerKey.campaignKey}`,
      );
    else {
      return this.http.get<OfferInstance>(
        `${environment.servicesApiUrl}/api/v3/offers/${offerKey.campaignKey}/${offerKey.couponId}`,
      );
    }
  }
}
